import { Node_Type } from 'ricos-schema';

const isContentStateEmpty = (contentState) => {
  const { blocks } = contentState;
  if (blocks.length === 0) {
    return true;
  }
  if (blocks.length > 1) {
    return false;
  }
  const firstBlock = blocks[0];
  const { text, type, depth } = firstBlock;
  return text === "" && type === "unstyled" && depth === 0;
};
const isRichContentEmpty = (contentState) => {
  var _a, _b, _c, _d;
  if (((_a = contentState.nodes) == null ? void 0 : _a.length) === 0) {
    return true;
  } else if (((_c = (_b = contentState.nodes) == null ? void 0 : _b.length) != null ? _c : 0) > 1) {
    return false;
  } else {
    const firstNode = (_d = contentState.nodes) == null ? void 0 : _d[0];
    const { nodes, type, paragraphData } = firstNode;
    return (nodes == null ? void 0 : nodes.length) === 0 && type === Node_Type.PARAGRAPH && [void 0, 0].includes(paragraphData == null ? void 0 : paragraphData.indentation);
  }
};

export { isContentStateEmpty, isRichContentEmpty };
//# sourceMappingURL=contentStateUtils.js.map
